import { graphql, useStaticQuery } from "gatsby";
import { Category } from "../../constants/categories.constants";
import { Sector } from "../../constants/sectors.constants";
import { ImageWithMetaInfo, ProjectMetaInfo, ProjectMetaInfoWithQueriedResources } from "../../types/app.types";
import { CarnetDePassagesImagesQuery } from "../../types/generated";

export const ProjectMetaInfoCarnetDePassages: ProjectMetaInfo = {
  name: "carnet-de-passages",
  displayName: "Carnet de Passages (FIA / AIT)",
  abbreviation: "CPD",
  subtitle: "Carnet de Passages en Douane Official Website",
  description: "The International Driving Permit (IDP) is an international travel document regulated by the United Nations that allows its holder to drive in a foreign country. We carried out a campaign and a complete redesign of the website to promote the website to those actively seeking information about IDPs.",
  categories: [
    Category.websites,
  ],
  sectors: [
    Sector.governmentAndNPO,
  ],
  url: "https://carnetdepassage.org/",
  hasPage: false,
  keywords: [
    'Carnet de Passages',
    'Carnet de Passages en Douane',
    'CPD',
    'FIA',
    'AIT',
    'web development',
    'web design',
    'multilingual website',
  ],
}

export const useCarnetDePassagesInfo = () => {
  const CarnetDePassagesImages: CarnetDePassagesImagesQuery = useStaticQuery(graphql`
    query CarnetDePassagesImages {
      featuredImage: file(relativePath: {eq: "images/carnet-de-passages/carnet-de-passages-featured-image-moving-taffic-at-dusk.jpg"}) {
        childImageSharp {
          gatsbyImageData(width: 1280, height: 720)
        }
      }
      gallery: allFile(
        sort: {fields: name}, 
        filter: {
          extension: {regex: "/(jpg)|(jpeg)|(png)/"}, 
          relativeDirectory: {eq: "images/carnet-de-passages/gallery"}
        }
      ) {
        edges {
          node {
            name
            childImageSharp {
              gatsbyImageData(width: 2560, height: 1440)
            }
          }
        }
      }
    }`
  )
  const imageMetaData: Partial<ImageWithMetaInfo>[] = [
    {
      title: 'Carnet de Passages Homepage Screenshot',
      alt: 'Carnet de Passages Homepage Screenshot, desktop version',
    },
  ]
  const info: ProjectMetaInfoWithQueriedResources = {
    ...ProjectMetaInfoCarnetDePassages,
    featuredImage: {
      image: CarnetDePassagesImages.featuredImage!.childImageSharp,
      title: 'Carnet de Passages Project Featured Image',
      alt: 'Carnet de Passages Project Featured Image',
    },
    gallery: CarnetDePassagesImages.gallery.edges.map((edge, i) => ({
      image: edge.node.childImageSharp?.gatsbyImageData,
      ...imageMetaData[i]
    }))
  }
  return info
}